import React, { useEffect, useState } from "react";
import axios from "axios";
import "./SuperAdminPage.css";
import CompanySurveyDetails from "./CompanySurveyDetails";
import SurveyEditPanel from "./SurveyEditPanel";
import AdminSurveyDetailPage from './AdminSurveyDetailPage';
import SurveyQuestionEditor from './SurveyQuestionEditor';
import { AuthProvider, useAuth } from '../context/AuthContext';


export default function AddSurvey() {

  const [companies, setCompanies] = useState([]);
  const [surveys, setSurveys] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [mode, setMode] = useState(null); // null | edit | view
  const [showAddModal, setShowAddModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { user, loading } = useAuth();
  const [editorSurveyId, setEditorSurveyId] = useState(null);
  // const [editorSurvey, setEditorSurvey] = useState([]);
  const [newSurvey, setNewSurvey] = useState({
  name: "",
  description: "",
  company_fk: 1,
  created_by: user?.id,
  survey_type_fk: selectedCompany
});

const [newCompany, setNewCompany] = useState({
  name: "",
  phone: "",
  email: "",
  address: "",
  created_by: user.id,
  survey_type_fk: selectedCompany
});

const [showAssignModal, setShowAssignModal] = useState(false);
const [availableSurveys, setAvailableSurveys] = useState([]);
const [assignForm, setAssignForm] = useState({
  survey_fk: "",
  expires_at: "",
  response_expected: 0
});

const [creating, setCreating] = useState(false);

const createSurvey = async (company) => {
  console.log(company)
  if (creating) return;

  if (!newSurvey.name.trim()) {
    alert("Survey name is required");
    return;
  }

  try {
    setCreating(true);

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/survey`,
      newSurvey
    );

    setShowAssignModal(false);

    setNewSurvey({
      name: "",
      description: "",
      company_fk: null,
      created_by: user.id,
      survey_type_fk: company.id
    });

    fetchCompanySurveys(selectedCompany);

  } catch (err) {
    alert(err.response?.data?.error || "Failed to create survey");
  } finally {
    setCreating(false);
  }
};



  // -------------------------
  // Fetch companies once
  // -------------------------



  useEffect(() => {
  if (selectedCompany) {
    setNewSurvey((prev) => ({
      ...prev,
      company_fk: null,
      survey_type_fk: selectedCompany.id
    }));
  }
}, [selectedCompany]);

  useEffect(() => {
    fetchCompanies();
  }, []);


  const fetchCompanies = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/superadmin/surveyTypes`
    );
    setCompanies(res.data || []);
  };

  // -------------------------
  // Fetch surveys on company click
  // -------------------------
// const fetchCompanySurveys = async (survey_type) => {
//   setSelectedCompany(survey_type);
//   setSelectedSurvey(null);

//   const res = await axios.get(
//     `${process.env.REACT_APP_API_BASE_URL}/superadmin/company/surveytype/${survey_type.id}/surveys`
//   );

//   const surveyList = res.data || [];
//   setSurveys(surveyList);

//   // ✅ AUTO SELECT FIRST SURVEY
//   if (surveyList.length > 0) {
//     setSelectedSurvey(surveyList[0]);
//   }
// };
let currentRequest = null;

const fetchCompanySurveys = async (survey_type) => {
  setSelectedCompany(survey_type);
  setSelectedSurvey(null);
  setSurveys([]);

  const controller = new AbortController();
  currentRequest?.abort();
  currentRequest = controller;

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/superadmin/company/surveytype/${survey_type.id}/surveys`,
      { signal: controller.signal }
    );

    setSurveys(res.data || []);
  } catch (err) {
    if (err.name !== "CanceledError") {
      console.error(err);
    }
  }
};

const openAssignModal = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/survey/unassigned/${selectedCompany.id}`
    );

    setAvailableSurveys(res.data || []);
    setShowAssignModal(true);

  } catch (err) {
    alert("Failed to load surveys");
  }
};

const filteredCompanies = companies.filter((c) =>
  c.name.toLowerCase().includes(searchTerm.toLowerCase())
);



  return (
    <div className="super-admin-container">

      {/* LEFT PANEL — COMPANIES */}
      <div className="side-panel">
        <div className="company-header">
  <h3>🎯 Surveys</h3>
  {/* <button className="add-company-btn" onClick={() => setShowAddModal(true)}>
    ➕
  </button> */}
</div>

        <div className="company-search">
 <input
  placeholder="Search Surveys..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
{searchTerm && filteredCompanies.length === 0 && (
  <div className="no-data">No matching Surveys found</div>
)}

</div>


        {companies.length === 0 && (
          <div className="no-data">No Surveys found</div>
        )}

        {filteredCompanies.map((c) => (

          <div
            key={c.id}
            className={`company-tile ${
              selectedCompany?.id === c.id ? "active" : ""
            }`}
            onClick={() => fetchCompanySurveys(c)}
          >
            {c.name}
          </div>
        ))}
      </div>

      {/* RIGHT PANEL — SURVEYS + DETAILS */}
      <div className="content-panel">

        {!selectedCompany && (
          <div className="empty-state">
            Select a Survey Type to view surveys
          </div>
        )}

        {selectedCompany &&  !editorSurveyId && (
  <>
    {/* PAGE TITLE */}
<div className="dashboard-header">
  <h2>📋 {selectedCompany.name}</h2>
</div>
    <div className="survey-header-row">
  <h3>📄 Available Surveys</h3>
  <button
    className="assign-btn"
    onClick={() => openAssignModal()}
  >
    ➕ Create Survey
  </button>
</div>


    

    {surveys.length === 0 && (
      <div className="no-data">No surveys assigned</div>
    )}

{surveys.map((s) => {
  const expanded = selectedSurvey?.survey_id === s.survey_id;

  return (
    <div
      key={s.survey_id}
      className={`survey-card ${expanded ? "active" : ""}`}
      onClick={() => setSelectedSurvey(expanded ? null : s)}
    >
      <div className="survey-row">
        <div>
          <b>{s.survey_name}</b>
          <div className="meta">
            Assigned To: {s.company_name || "Un-assigned"}<br />
            {/* Expected: {s.responses_expected || "-"}<br /> */}
            {/* Assigned: {new Date(s.assigned_on).toLocaleDateString()} */}
            Created on: {new Date(s.created_at).toLocaleDateString()}
          </div>
        </div>

        <div className={`status ${s.status}`}>{s.status}</div>
      </div>


      {expanded && (
        <div className="survey-actions">
          <button
            className="btn-edit"
            onClick={(e) => {
              e.stopPropagation();
              // setMode("edit");
              setEditorSurveyId(s.survey_id);
            }}
          >
            ✏ Edit
          </button>
        </div>
      )}
      
    </div>
  );
})}
  </>
)}

{editorSurveyId && (
  <SurveyQuestionEditor
    surveyId={editorSurveyId}
    surveyTypeId={selectedCompany?.id}  
    onBack={() => setEditorSurveyId(null)}
  />
)}


{showAssignModal && (
  <div className="modal-overlay">
    <div className="modal-box">

      <h2>📄 Add Survey</h2>

      <input
        type="text"
        placeholder="Survey Name *"
        value={newSurvey.name}
        onChange={(e) =>
          setNewSurvey({ ...newSurvey, name: e.target.value })
        }
      />

      <textarea
        placeholder="Description"
        rows={4}
        value={newSurvey.description}
        onChange={(e) =>
          setNewSurvey({ ...newSurvey, description: e.target.value })
        }
      />

      <div className="modal-actions">
        <button
          className="modal-cancel"
          onClick={() => setShowAssignModal(false)}
        >
          Cancel
        </button>

<button
  className="modal-save"
  disabled={creating}
  onClick={() => createSurvey(selectedCompany)}
>
  {creating ? "Creating..." : "Create Survey"}
</button>

      </div>

    </div>
  </div>
)}

      </div>
    </div>
  );
}
